import AddPayments from './index.vue'

const obj = {}

obj.install = function (Vue) {
  const constructor = Vue.extend(AddPayments)
  const payment = new constructor()
  payment.$mount(document.createElement('div'))
  document.body.appendChild(payment.$el)
  Vue.prototype.$payment = payment
}
export default obj
